import { Link } from 'react-router-dom';
import Button from '../../../components/base/Button';

export default function AboutSection() {
  const aboutCards = [
    {
      title: 'الرؤية',
      description: 'أن نكون الاسم الأول في الخليج في المقاولات، التسليح، وتجارة المعادن',
      icon: 'ri-eye-line'
    },
    {
      title: 'الرسالة',
      description: 'حلول موثوقة ومستدامة بجودة عالمية والتزام بالوقت والتكلفة',
      icon: 'ri-target-line'
    },
    {
      title: 'القيم',
      description: 'الشفافية • الاحتراف • الأمان • الاستدامة • الابتكار',
      icon: 'ri-heart-line'
    }
  ];

  return (
    <section className="py-12" style={{ backgroundColor: '#F7F7F7' }}>
      <div className="container mx-auto px-4">
        <div className="bg-white rounded-xl shadow-lg p-8 lg:p-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* العمود الأيسر - المحتوى الرئيسي */}
            <div className="order-2 lg:order-1">
              <h2 className="text-4xl lg:text-5xl font-bold mb-6" style={{ color: '#E71B25' }}>
                من نحن
                <span className="text-2xl lg:text-3xl block mt-2" style={{ color: '#595A5C' }}>
                  About Us
                </span>
              </h2>
              
              <p className="text-lg leading-relaxed mb-8" style={{ color: '#595A5C' }}>
                شركة فيبا التجارية منصة متكاملة بحلول هندسية واستراتيجية وأمنية، بشراكات محلية ودولية، وتنفيذ بمقاييس عالمية.
              </p>
              
              <Link to="/about">
                <Button 
                  variant="primary" 
                  size="lg" 
                  className="hover:scale-105 transition-transform duration-300 whitespace-nowrap"
                >
                  تعرّف علينا أكثر
                  <i className="ri-arrow-left-line mr-2"></i>
                </Button>
              </Link>
            </div>
            
            {/* العمود الأيمن - البطاقات */}
            <div className="order-1 lg:order-2">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2 gap-6">
                {aboutCards.map((card, index) => (
                  <div 
                    key={index}
                    className="bg-white rounded-xl p-5 shadow-sm border border-gray-100 hover:scale-102 hover:shadow-md transition-all duration-300 cursor-pointer"
                  >
                    <div className="flex items-start gap-4">
                      <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0" style={{ backgroundColor: '#E71B25' }}>
                        <i className={`${card.icon} text-white text-lg`}></i>
                      </div>
                      <div className="flex-1">
                        <h3 className="text-lg font-bold mb-2" style={{ color: '#E71B25' }}>
                          {card.title}
                        </h3>
                        <p className="text-sm leading-relaxed" style={{ color: '#595A5C' }}>
                          {card.description}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}